import { c as _c } from "react/compiler-runtime";
import { Field } from "@base-ui/react/field";
import { type FieldVariant, fieldBaseClasses, fieldVariants } from "@/components/ui/field-variants";
import { cn } from "@/lib/utils";
type TextareaProps = React.ComponentProps<"textarea"> & {
  variant?: FieldVariant;
};
function Textarea(t0) {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const variant = t1 === undefined ? "default" : t1;
  const t2 = fieldVariants[variant];
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn(fieldBaseClasses, "min-h-80 py-2 text-base sm:min-h-48", t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props) {
    t4 = <textarea {...props} />;
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Field.Control className={t3} data-slot="textarea" render={t4} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export { Textarea };